import React from "react";
import CruiseWizardPage from "@/pages/Cruise/CruiseWizardPage";
import {CruiseDuration} from "@/models/Enums";
import EnumProvider from "@/providers/EnumProvider";

import styles from "./Duration.module.scss";
import Localizer from "@/localization/Localizer";

export interface IDurationProps {
}

interface IDurationState {
}

export default class Duration extends CruiseWizardPage<IDurationProps, IDurationState> {

    state: IDurationState = {
    };

    public async selectAsync(duration: CruiseDuration): Promise<void> {
        this.wizard.duration = duration;
        this.saveContext();
        await super.nextAsync();
    }

    public get canNext(): boolean {
        return (this.wizard.duration != null);
    }
    
    public get duration(): CruiseDuration | null {
        return this.wizard.duration;
    }

    public get title(): string | null {
        return (this.isFishing)
            ? Localizer.cruiseWizardDurationFishingTitle
            : Localizer.cruiseWizardDurationTitle;
    }

    public renderItem(duration: CruiseDuration): React.ReactNode {
        const label: string = EnumProvider.getCruiseDurationText(duration);
        const selectedStyle: any = (duration == this.duration) && styles.selected;
        const mobileStyle: any = (this.mobile) && styles.mobile;
        return (
            <div className={this.css(styles.item, mobileStyle, selectedStyle)} onClick={() => this.selectAsync(duration)}>
                <div className={styles.label}>
                    <div>
                        <span>{label}</span>
                    </div>
                </div>
            </div>
        );
    }

    public renderContent(): React.ReactNode {
        
        const row1: CruiseDuration[] = (this.isFishing)
            ? [CruiseDuration.H1, CruiseDuration.H2, CruiseDuration.H3]
            : (this.isHovercraft)
                ? [CruiseDuration.H1, CruiseDuration.H2]
                : [CruiseDuration.JustRide, CruiseDuration.H1, CruiseDuration.H2];
        
        const row2: CruiseDuration[] = (this.isFishing)
            ? [CruiseDuration.H4, CruiseDuration.H5]
            : (this.isHovercraft)
                ? []
                : [CruiseDuration.H3, CruiseDuration.H4, CruiseDuration.H5];
        
        return (
            <div className={styles.duration}>

                <div className={this.css(styles.container, this.mobile && styles.mobile)}>

                    {
                        (row1.length > 0) &&
                        (
                            <div className={styles.row}>

                                { row1.map(duration => this.renderItem(duration)) }

                            </div>
                        )
                    }

                    {
                        (row2.length > 0) &&
                        (
                            <div className={styles.row}>

                                { row2.map(duration => this.renderItem(duration)) }

                            </div>
                        )
                    }

                </div>

            </div>
        );
    }
}